/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Settings_Billing_AmountInputs */

const en_settings_billing_amount = /** @type {(inputs: Settings_Billing_AmountInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Amount`)
};

const zh_settings_billing_amount = /** @type {(inputs: Settings_Billing_AmountInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`金额`)
};

/**
* | output |
* | --- |
* | "Amount" |
*
* @param {Settings_Billing_AmountInputs} inputs
* @param {{ locale?: "en" | "zh" }} options
* @returns {LocalizedString}
*/
const settings_billing_amount = /** @type {((inputs?: Settings_Billing_AmountInputs, options?: { locale?: "en" | "zh" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Settings_Billing_AmountInputs, { locale?: "en" | "zh" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_settings_billing_amount(inputs)
	return zh_settings_billing_amount(inputs)
});
export { settings_billing_amount as "settings.billing.amount" }